
NOTIFACTION_DEFAULT_DURATION = 15000
MONITOR_CHECK_INTERVAL       = 60000
NOTIFICATIONS_REPEAT_INTERVAL = 1000


# -------
# Уведомления
# -------
NOTIFICATIONS =
  # ---
  # Вовремя доставили заказ
  # ---
  is_past_delivery_end_deadline: (order) ->
    title = @get('env').translate('monitor.notifications.common_title',
      number: order.get('number'), name: order.get('contact_name'))

    message = @get('env').translate('monitor.notifications.delivery_end_deadline',
      when:   @formatDate(order.get('deliveryEndDeadlineAt')),
      status: @get('env').translate("order.status.#{order.get('status')}"))

    duration = @get('notificationDuration')

    return if localStorage.getItem('hideOrderNotifications') == 'true'
    @get('notifier').pushNotification({type: 'error', duration, title, message,\
      handler: @makeNotificationHandler(order) })

  # ---
  # Вовремя не начали доставлять заказ
  # ---
  is_past_delivery_start_deadline: (order) ->
    title = @get('env').translate('monitor.notifications.common_title',
      number: order.get('number'), name: order.get('contact_name'))

    message = @get('env').translate('monitor.notifications.delivery_start_deadline',
      when:   @formatDate(order.get('deliveryStartDeadlineAt')),
      status: @get('env').translate("order.status.#{order.get('status')}"))

    duration = @get('notificationDuration')

    return if localStorage.getItem('hideOrderNotifications') == 'true'
    @get('notifier').pushNotification({type: 'warning', duration, title, message,\
      handler: @makeNotificationHandler(order) })

  # ---
  # Вовремя не приготовили заказ
  # ---
  is_past_cooking_end_deadline: (order) ->
    title = @get('env').translate('monitor.notifications.common_title',
      number: order.get('number'), name: order.get('contact_name'))

    message = @get('env').translate('monitor.notifications.cooking_end_deadline',
      when:   @formatDate(order.get('cookingEndDeadlineAt')),
      status: @get('env').translate("order.status.#{order.get('status')}"))

    duration = @get('notificationDuration')

    return if localStorage.getItem('hideOrderNotifications') == 'true'
    @get('notifier').pushNotification({type: 'warning', duration, title, message,\
      handler: @makeNotificationHandler(order) })

  # ---
  # Вовремя не начали готовить заказ
  # ---
  is_past_cooking_start_deadline: (order) ->
    title = @get('env').translate('monitor.notifications.common_title',
      number: order.get('number'), name: order.get('contact_name'))

    message = @get('env').translate('monitor.notifications.cooking_start_deadline',
      when:   @formatDate(order.get('cookingStartDeadlineAt')),
      status: @get('env').translate("order.status.#{order.get('status')}"))

    duration = @get('notificationDuration')

    return if localStorage.getItem('hideOrderNotifications') == 'true'
    @get('notifier').pushNotification({type: 'warning', duration, title, message,\
      handler: @makeNotificationHandler(order) })

  # ---
  # Вовремя не подтвердили заказ
  # ---
  is_past_confirm_deadline: (order) ->
    title = @get('env').translate('monitor.notifications.common_title',
      number: order.get('number'), name: order.get('contact_name'))

    message = @get('env').translate('monitor.notifications.confirm_deadline',
      when:   @formatFromNow(order.get('published_at')))

    duration = @get('notificationDuration')

    return if localStorage.getItem('hideOrderNotifications') == 'true'
    @get('notifier').pushNotification({type: 'warning', duration, title, message,\
      handler: @makeNotificationHandler(order) })

  # ---
  # Вовремя не оплатили заказ
  # ---
  is_past_payment_deadline: (order) ->
    title = @get('env').translate('monitor.notifications.common_title',
      number: order.get('number'), name: order.get('contact_name'))

    message = @get('env').translate('monitor.notifications.payment_deadline')

    duration = @get('notificationDuration')

    return if localStorage.getItem('hideOrderNotifications') == 'true'
    @get('notifier').pushNotification({type: 'warning', duration, title, message,\
      handler: @makeNotificationHandler(order) })

  # ---
  # Вовремя не назначили курьера
  # ---
  is_past_courier_deadline: (order) ->
    title = @get('env').translate('monitor.notifications.common_title',
      number: order.get('number'), name: order.get('contact_name'))

    message = @get('env').translate('monitor.notifications.courier_deadline',
      when: @formatDate(order.get('pick_up_at')))

    duration = @get('notificationDuration')

    return if localStorage.getItem('hideOrderNotifications') == 'true'
    @get('notifier').pushNotification({type: 'warning', duration, title, message,\
      handler: @makeNotificationHandler(order) })

  # ---
  # Напоминание о подтверждении заказа
  # ---
  is_just_created: (order) ->
    title = @get('env').translate('monitor.notifications.common_title',
      number: order.get('number'), name: order.get('contact_name'))

    message = @get('env').translate('monitor.notifications.just_created',
      when:   @formatDuring(order.get('confirmDeadlineAt')))

    duration = @get('notificationDuration')

    return if localStorage.getItem('hideOrderNotifications') == 'true'
    @get('notifier').pushNotification({type: 'info', duration, title, message,\
      handler: @makeNotificationHandler(order) })

  # ---
  # Вовремя не подтвердили заказ рестораном
  # ---
  is_past_restaurant_confirm_deadline: (order) ->
    title = @get('env').translate('monitor.notifications.common_title',
      number: order.get('number'), name: order.get('contact_name'))

    message = @get('env').translate('monitor.notifications.restaurant_confirm_deadline',
      when: @formatDate(order.get('pick_up_at')))

    duration = @get('notificationDuration')

    return if localStorage.getItem('hideOrderNotifications') == 'true'
    @get('notifier').pushNotification({type: 'warning', duration, title, message,\
      handler: @makeNotificationHandler(order) })

  # ---
  # Заказ стал отложенным
  # ---
  became_delayed: (order) ->
    title = @get('env').translate('monitor.notifications.common_title',
      number: order.get('number'), name: order.get('contact_name'))

    message = @get('env').translate('monitor.notifications.delayed_order')

    duration = @get('notificationDuration')

    return if localStorage.getItem('hideOrderNotifications') == 'true'
    @get('notifier').pushNotification({type: 'info', duration, title, message,\
      handler: @makeNotificationHandler(order) })

  # ---
  # Заказ стал активным
  # ---
  became_active: (order) ->
    title = @get('env').translate('monitor.notifications.common_title',
      number: order.get('number'), name: order.get('contact_name'))

    message = @get('env').translate('monitor.notifications.active_order',
      when: @formatDate(order.get('delivery_at')))

    duration = @get('notificationDuration')

    return if localStorage.getItem('hideOrderNotifications') == 'true'
    @get('notifier').pushNotification({type: 'info', duration, title, message,\
      handler: @makeNotificationHandler(order) })

  # ---
  # Пришел новый заказ
  # ---
  created: (order) ->
    title = @get('env').translate('monitor.notifications.new_order_title',
      number: order.get('number'))

    message = [ order.get('contact_name'), order.get('address_text') ].join(', ')

    duration = if localStorage.getItem('soundNotificationsRepeat') == 'true' then null else @get('notificationDuration')

    sound = localStorage.getItem('soundNotifications') == 'true' && localStorage.getItem('soundNotificationsVerbose') != 'true'

    sound_repeat = if localStorage.getItem('soundNotificationsRepeat') == 'true' then @get('notificationsRepeatSoundInterval') else null

    return if localStorage.getItem('hideOrderNotifications') == 'true'
    @get('notifier').pushNotification({type: 'success', duration, sound, sound_repeat, title, message,\
      handler: @makeNotificationHandler(order) })

  # ---
  # Заказ был оплачен
  # ---
  paid: (order) ->
    title = @get('env').translate('monitor.notifications.paid',
      number: order.get('number'))

    message = [ order.get('contact_name'), order.get('address_text') ].join(', ')

    duration = @get('notificationDuration')

    sound = localStorage.getItem('soundNotifications') == 'true' && localStorage.getItem('soundNotificationsVerbose') != 'true'

    return if localStorage.getItem('hideOrderNotifications') == 'true'
    @get('notifier').pushNotification({type: 'info', duration, sound, title, message,\
      handler: @makeNotificationHandler(order) })



  # ---
  # Изменился статус заказа
  # ---
  status_changed: (order, status) ->
    title = @get('env').translate('monitor.notifications.common_title',
      number: order.get('number'), name: order.get('contact_name'))

    statusText = @get('env').translate("order.status.#{status}")
    message = @get('env').translate('monitor.notifications.status_changed',
      status: statusText)

    duration = @get('notificationDuration')

    type = switch status
      when 'undo' then 'error'
      when 'complete' then 'success'
      else 'info'

    return if localStorage.getItem('hideOrderNotifications') == 'true'
    @get('notifier').pushNotification({type, duration, title, message,\
      handler: @makeNotificationHandler(order) })

  # ---
  # Курьер подтвердил заказ
  # ---
  courier_confirmed: (order, courier, confirmed_at) ->
    title = @get('env').translate('monitor.notifications.common_title',
      number: order.get('number'), name: order.get('contact_name'))

    message = @get('env').translate('monitor.notifications.courier_confirmed',
      courier_name: courier.get('name'))

    duration = @get('notificationDuration')

    type = 'success'

    return if localStorage.getItem('hideOrderNotifications') == 'true'
    @get('notifier').pushNotification({type, duration, title, message,\
      handler: @makeNotificationHandler(order) })


  # ---
  # Пришло сообщение по заказу
  # ---
  message_sent: (order, message) ->
    title = @get('env').translate('monitor.notifications.common_title',
      number: order.get('number'), name: order.get('contact_name'))

    duration = null
    type = 'info'

    return if localStorage.getItem('hideOrderNotifications') == 'true'
    @get('notifier').pushNotification({type, duration, title, message,\
      handler: @makeNotificationHandler(order) })

  # ---
  # Ресторан подтвердил заказ (на кухне)
  # ---
  restaurant_confirmed: (order, confirmed_at) ->
    title = @get('env').translate('monitor.notifications.common_title',
      number: order.get('number'), name: order.get('contact_name'))

    message = @get('env').translate('monitor.notifications.restaurant_confirmed',
      restaurant_name: order.get('restaurant.name'))

    duration = @get('notificationDuration')

    type = 'success'

    return if localStorage.getItem('hideOrderNotifications') == 'true'
    @get('notifier').pushNotification({type, duration, title, message,\
      handler: @makeNotificationHandler(order) })

  # ---
  # Ресторан подтвердил заказ (на кухне)
  # ---
  restaurant_confirmed: (order, confirmed_at) ->
    title = @get('env').translate('monitor.notifications.common_title',
      number: order.get('number'), name: order.get('contact_name'))

    message = @get('env').translate('monitor.notifications.restaurant_confirmed',
      restaurant_name: order.get('restaurant.name'))

    duration = @get('notificationDuration')

    type = 'success'

    return if localStorage.getItem('hideOrderNotifications') == 'true'
    @get('notifier').pushNotification({type, duration, title, message,\
      handler: @makeNotificationHandler(order) })

  # ---
  # Начать приготовление
  # ---
  cooking_start: (order, pick_up_at) ->
    title = @get('env').translate('monitor.notifications.common_title',
      number: order.get('number'), name: order.get('contact_name'))

    message = @get('env').translate('monitor.notifications.cooking_start',
      when: @formatDate(pick_up_at) )

    duration = @get('notificationDuration')

    type = 'info'

    return if localStorage.getItem('hideOrderNotifications') == 'true'
    @get('notifier').pushNotification({type, duration, title, message,\
      handler: @makeNotificationHandler(order) })

# ---
# Сервис предоставляет возможности для отслеживания состояния текущих
# заказов в фоне
# ---
module.exports = Em.Service.extend
  session:  Em.inject.service()
  store:    Em.inject.service()
  notifier: Em.inject.service()
  env:      Em.inject.service('environment')
  realTime: Em.inject.service('realTime')

  # ---
  # Состояния
  # ---
  globalTime: (->
    return @get('globalTimeOverride') if @get('env.features.timeMachine')
    new Date
  ).property().volatile()

  globalTimeOverride: new Date

  orders: []
  isLoading: false  # загружаются ли заказы
  isActive:  false  # активен ли монитор (не активен, если сессия пуста)

  delayedOrders: (->
    @get('orders').filter((order) -> order.get('isDelayed') and order.get('parent_id') == null)
  ).property('orders.[]', 'orders.@each.status', 'orders.@each')

  currentOrders: (->
    filterStatus = (k, v) ->
      not (v in [ 'undo', 'complete'])

    filterDelayed = (k, v) ->
      not v

    filterNested = (k, v) ->
      v == null

    filterTakeaway = (k, v) ->
      not v or not (localStorage.getItem('hidePickupOrdersAtNow') == 'true')

    Em.ArrayProxy.createWithMixins Em.ArrangeableMixin,
      content: @get('orders')
      sortProperties: [ 'orderMapSortWeight', 'delivery_at', 'id' ]
      sortAscending: false
      filterProperties: [
        [ 'isDelayed',  filterDelayed]
        [ 'status',     filterStatus ]
        [ 'takeaway',   filterTakeaway ]
        [ 'parent_id',  filterNested ]
      ]
  ).property('orders')

  observeEnabled: (->
    @get('isActive') and not @get('isLoading')
  ).property('isLoading', 'isActive')

  ORDERS_LIMIT: 400

  # Кеши для хранения последних уведомлений и состояний isDelayed
  # Сбрасываются при смене сессии
  notificationsCache: Em.Object.create()
  delayedCache:       Em.Object.create()

  # ---
  # Утилиты для формирования времени, используют globalTime в качестве
  # указателя на текущий момент времени
  # ---
  formatDate: (date) ->
    now = @get('globalTime')
    yesterday = moment(now).subtract(1, 'days')

    day = if moment(date).isSame(now, 'day')
      @get('env').translate('date.today')
    else if moment(date).isSame(yesterday, 'day')
      @get('env').translate('date.yesterday')
    else
      moment(date).format('D MMMM')

    time = moment(date).format('H:mm')
    "#{day} #{@get('env').translate('date.at')} #{time}"

  formatFromNow: (date) ->
    moment(date).from(@get('globalTime'))

  formatDuring: (date) ->
    values =
      hours   : moment(date).diff(@get('globalTime'), 'hours')
      minutes : moment(date).diff(@get('globalTime'), 'minutes')
      seconds : moment(date).diff(@get('globalTime'), 'seconds')

    durationText = ''
    for measure in [ 'hours', 'minutes', 'seconds']
      if values[measure] > 0
        durationText = @get('env').translate("date.during_#{measure}", count: values[measure])
        break

    "#{@get('env').translate('date.during')} #{durationText}"

  checkpointsObserver: (->
    return unless @get('observeEnabled')
    orders = @get('orders')

    cache = @get('notificationsCache')

    orders.forEach (order) =>
      checkpoints         = order.get('checkpoints')
      previousCheckpoints = cache.get(order.get('id')) ? []

      _.select checkpoints, (cp) =>
        unless _.find(previousCheckpoints, (c) => c.checkpoint is cp.checkpoint)
          @onNewCheckpoint(order, cp)

      cache.set(order.get('id'), checkpoints)
  ).observes('orders.@each.checkpoints').on('init')

  isDelayedObserver: (->
    return unless @get('observeEnabled')

    @get('orders').forEach (order) =>
      cache = @get('delayedCache')

      delayedWas    = cache.get(order.get('id'))
      delayedBecome = order.get('isDelayed')

      if delayedWas? and delayedWas isnt delayedBecome
        @onIsDelayedChanged(order)

      cache.set(order.get('id'), delayedBecome)
  ).observes('orders.@each.isDelayed')

  notifationsEnabledFor: (type) ->
    return false if localStorage.getItem('hideOrderNotifications') == 'true'

    return true if @get('env.features.mapNotifications')

    if type is 'is_just_created'
      return true

    # Работает только в разделе карты
    path = App.__container__
      .lookup('controller:application')
      .get('currentPath')

    Boolean(path.match /orders\.map.*/)

  # У заказа возник новый просроченный чекпоинт
  onNewCheckpoint: (order, checkpoint) ->
    if @notifationsEnabledFor(checkpoint.checkpoint)
      NOTIFICATIONS[checkpoint.checkpoint]?.call(@, order)

  # У заказа изменилось свойство isDelayed
  onIsDelayedChanged: (order) ->
    if order.get('isDelayed')
      NOTIFICATIONS.became_delayed.call(@, order) if @notifationsEnabledFor('became_delayed')
    else
      NOTIFICATIONS.became_active.call(@, order)  if @notifationsEnabledFor('became_active')

  monitorCheckInterval: (->
    if parseInt(localStorage.getItem('monitorCheckInterval')) > 0
      parseInt(localStorage.getItem('monitorCheckInterval'))*1000*60
    else
      MONITOR_CHECK_INTERVAL
  ).property()


  # ---
  # Продолжительность показа уведомлений
  # ---
  notificationDuration: (->
    if parseInt(localStorage.getItem('notificationDuration')) > 0
      parseInt(localStorage.getItem('notificationDuration'))*1000
    else
      NOTIFACTION_DEFAULT_DURATION
  ).property()


  notificationsRepeatSoundInterval: (->
    if parseInt(localStorage.getItem('notificationsRepeatSoundInterval')) > 0
      parseInt(localStorage.getItem('notificationsRepeatSoundInterval'))*1000
    else
      NOTIFICATIONS_REPEAT_INTERVAL
  ).property()

  recheckOrders: ->
    if @get('observeEnabled')
      Em.Logger.log "[monitor] Пересчитываем чекпоинты заказов"
      @notifyPropertyChange('globalTime')
    Em.run.later(@recheckOrders.bind(@), @get('monitorCheckInterval'))

  runRecheckOrders: (->
    if @get('env.features.timeMachine')
      Em.Logger.log("[monitor] Машина времени включена, пересчет времени в заказах только вручную")
      return

    Em.Logger.log("[monitor] Устанавливаем интервал проверки заказов в #{@get('monitorCheckInterval')/1000} секунд")
    @recheckOrders()
  ).on('init')


  makeNotificationHandler: (order) ->
    =>
      App.__container__.lookup('controller:application')
        .transitionToRoute('orders.map.order', order.get('id'))

  # ---
  # Дальше идет все про изменение сессии:
  #   запросить новые заказы, убрать за собой после логаута и т.д.
  # ---
  refetchOrders: (->
    @sessionTeardown()

    @set('isActive', false)

    user = @get('session.currentUser')
    return unless user

    Em.Logger.log("[monitor] Запрашиваем новые заказы")

    return if @get('isLoading')
    @set('isLoading', true)

    @get('store').find('order', {
      status: [ 'pending', 'confirm', 'delivery', 'preparing', 'prepared'],
      per_page: @get('ORDERS_LIMIT')
      sort: [ 'delivery_at ASC']
      active:   true
    }).then (orders) =>
      @sessionInitialize()
      @set('isLoading', false)
      @set('isActive',  true)
      @set('orders', orders.get('content'))
  ).observes('session.currentUser').on('init')

  REAL_TIME_EVENTS: [
    'orderCreated'
    'orderPaid'
    'orderMessageSent'
    'orderStatusChanged'
    'orderCourierConfirmed'
    'orderRestaurantConfirmed'
    'orderCookingStart'
  ]

  sessionInitialize: ->
    @get('REAL_TIME_EVENTS').forEach (event) =>
      handler = @[ event ]
      @get('realTime').on(event, @, handler) if handler

    # Очищаем кеш
    @set('notificationsCache', Em.Object.create())
    @set('delayedCache',       Em.Object.create())

  sessionTeardown: ->
    @get('REAL_TIME_EVENTS').forEach (event) =>
      handler = @[ event ]
      @get('realTime').off(event, @, handler) if handler

  # ---
  # Обработка событий от realTime-сервиса
  # ---
  orderCreated: (order) ->
    orders = @get('orders')
    if orders.indexOf(order) is -1
      orders.unshiftObject(order)

    NOTIFICATIONS.created?.call(@, order)

  orderStatusChanged: (order, status, statusWas) ->
    NOTIFICATIONS.status_changed?.call(@, order, status, statusWas)

  orderCourierConfirmed: (order, courier, confirmedAt) ->
    NOTIFICATIONS.courier_confirmed?.call(@, order, courier, confirmedAt)

  orderMessageSent: (order, message) ->
    NOTIFICATIONS.message_sent?.call(@, order, message)

  orderRestaurantConfirmed: (order, status) ->
    NOTIFICATIONS.restaurant_confirmed?.call(@, order)

  orderCookingStart: (order, pick_up_at) ->
    NOTIFICATIONS.cooking_start?.call(@, order, pick_up_at)

  orderPaid: (order) ->
    NOTIFICATIONS.paid?.call(@, order)


